import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getFormatMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import {
    validateDateOfBirth,
    validateEmail,
    validateGender,
    validatePhone,
    validatePostcode,
    validateServiceId,
    validateUniqueIdentifier
} from '../../../utils/formValidation/validationFunctions';
import { getNameRegExp } from '../../../utils/formValidation/validationPatterns';
import {
    validateFirstName,
    validateLastName,
    validateMiddleName,
    validatePreferredName,
    validateReferralDate
} from '../validation/validationFunctions';

export const validate = (newEntry, initialStateOnEntry) => {
    let newErrors = {};

    newErrors = validateFirstName(newEntry.firstName, newErrors);
    newErrors = validateMiddleName(newEntry.middleName, newErrors);
    newErrors = validateLastName(newEntry.lastName, newErrors);
    newErrors = validatePreferredName(newEntry.preferredName, newErrors);
    newErrors = validateUniqueIdentifier(
        newEntry.uniqueIdentifierType,
        newEntry.uniqueIdentifier,
        newEntry.repeatUniqueIdentifier,
        newErrors
    );
    newErrors = validatePostcode(newEntry.postcode, newErrors);
    newErrors = validatePhone(newEntry.primaryPhoneNumber, newErrors, 'primaryPhoneNumber');
    newErrors = validatePhone(newEntry.secondaryPhoneNumber, newErrors, 'secondaryPhoneNumber');
    newErrors = validateEmail(newEntry.emailAddress, newErrors);
    newErrors = validateReferralDate(newEntry.referralDate, newErrors);
    newErrors = validateServiceId(newEntry.serviceId, newErrors);
    newErrors = validateGender(newEntry.genderId, newErrors);

    if (
        newEntry.preferredPronouns &&
        !getNameRegExp().test(newEntry.preferredPronouns)
    ) {
        newErrors = {
            ...newErrors,
            preferredPronouns: {
                error: true,
                message: getFormatMessage('Preferred pronouns other name')
            }
        };
    }
    if (!newEntry.statusId) {
        newErrors = {
            ...newErrors,
            statusId: { error: true, message: getSelectMessage('status') }
        };
    }
    if (
        !newEntry.statusReasonId &&
        (newEntry.statusId !== initialStateOnEntry.statusId ||
            newEntry.statusReasonId !== initialStateOnEntry.statusReasonId)
    ) {
        newErrors = {
            ...newErrors,
            statusReasonId: { error: true, message: getSelectMessage('status reason') }
        };
    }

    newErrors = validateDateOfBirth(newEntry.dateOfBirth, newErrors);

    if (!newEntry.eligibilityGroupId) {
        newErrors = {
            ...newErrors,
            eligibilityGroupId: {
                error: true,
                message: getSelectMessage('eligibility group', 'an')
            }
        };
    }

    if (!newEntry.dataProtectionId) {
        newErrors = {
            ...newErrors,
            dataProtectionId: { error: true, message: getSelectMessage('data protection option') }
        };
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialStateOnEntry);
    return newErrors;
};
